import { Theme } from '@mui/material';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
    children?: React.ReactElement;
    tabValue: string;
    selectedTab: string;
}

export default function PillTabContent({ children, tabValue, selectedTab }: Props) {
    const { classes } = useStyles();

    if (tabValue !== selectedTab) return null;

    return <div className={classes.contentContainer}>{children}</div>;
}

const useStyles = makeStyles()((theme: Theme) => ({
    contentContainer: {
        flexBasis: 0,
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflowY: 'scroll',
        backgroundColor: theme.palette.backgroundMainLayout.main,
        padding: theme.spacing(2),
        borderRadius: '20px',
    },
}));
